// SocketContext.js
import { createContext, useContext, useRef, useEffect } from 'react';
import { io } from 'socket.io-client';
import apis from '../services/Apis';

const SocketContext = createContext(null);
export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef();

  useEffect(() => {
    socketRef.current = io(apis.BASE_LOCAL_URL);
    return () => socketRef.current.disconnect();
  }, []);

  return (
    <SocketContext.Provider value={socketRef.current}>
      {children}
    </SocketContext.Provider>
  );
};
